// Import the WhisperSTT class from the library
import { WhisperSTT } from "whisper-speech-to-text"

import { Injectable, isDevMode } from '@angular/core'
import { log } from '@nx-superprep/utils'

@Injectable({providedIn: 'root'})
export class WhisperService {

  transcription = ''

  // Create a new instance of the WhisperSTT class, passing your OpenAI API key to the constructor
  whisper = new WhisperSTT(isDevMode() ? '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':'')

  // Start recording audio
  startRecording() {
    return (!this.whisper.isStopped || this.whisper.isRecording) ? Promise.reject('already recording') : this.whisper.startRecording()
  }
  // Pause the recording
  pauseRecording() {
    return !this.whisper.isRecording ? Promise.reject('not recording') : this.whisper.pauseRecording()
  }
  // Resume the recording
  resumeRecording() {
    return !this.whisper.isPaused ? Promise.reject('not recording') : this.whisper.resumeRecording()
  }

  // Stop the recording and get the transcription
  stopRecording(onFinish?: (arg0: string) => void) {
    return !this.whisper.isRecording ? Promise.reject('not recording') : this.whisper.stopRecording((text) => {
      log.debug('Transcription:', text)
      this.transcription = text
      if (onFinish) { onFinish(this.transcription); }
    })
  }
}
